import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// appsetup - Get All (Read)
export const GetAllAppSetUp = createAsyncThunk(
  "productmanage/app-setup/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Customization.AppSetUp}?email=${filter?.email || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// AppSetUp - Get (Read)
export const GetAppSetUp = createAsyncThunk(
  "productmanage/app-setup/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Customization.AppSetUp}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// AppSetUp - Create (Add)
export const AddAppSetUp = createAsyncThunk(
  "productmanage/app-setup/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Customization.AppSetUp, data);
      return res; // The new AppSetUp object
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// AppSetUp - Update
export const UpdateAppSetUp = createAsyncThunk(
  "productmanage/app-setup/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Customization.AppSetUp}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// AppSetUp - Delete
export const DeleteAppSetUp = createAsyncThunk(
  "productmanage/app-setup/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.Customization.AppSetUp}/${id}`);
      return id; // Return the id of the deleted AppSetUp
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// AppSetUp - Status
export const StatusAppSetUp = createAsyncThunk(
  "productmanage/app-setup/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Customization.AppSetUp}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "app-setup",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetAppSetUp, AddAppSetUp, UpdateAppSetUp, DeleteAppSetUp
      .addCase(GetAllAppSetUp.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllAppSetUp.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllAppSetUp.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAppSetUp.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAppSetUp.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetAppSetUp.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AddAppSetUp.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddAppSetUp.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddAppSetUp.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdateAppSetUp.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateAppSetUp.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (appsetup) => appsetup.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdateAppSetUp.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(DeleteAppSetUp.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteAppSetUp.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (appsetup) => appsetup.id !== action.payload.id
        ); // Remove the AppSetUp with the deleted id
      })
      .addCase(DeleteAppSetUp.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      //
      .addCase(StatusAppSetUp.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusAppSetUp.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (appsetup) => appsetup.id !== action.payload.id
        ); // Remove the appsetup with the deleted id
      })
      .addCase(StatusAppSetUp.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
